<template>
  <div class="educationList">
  <van-field
  readonly
  clickable
  :label="label"
  :value="value"
  :placeholder="placeholder"
  @click="openSelect"
/>

  <van-popup v-model="showPicker" position="bottom">
    <van-picker :columns="columns"  @change="onChange" 
       show-toolbar
        title=""
        :default-index="defaultIndex"
        @cancel="onCancel"
        @confirm="onConfirm"
      confirm-button-text="确认" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'educationList',
  //用于数据初始化
  created:function(){},
  data () {
    return {
      columns: ['小学','初中','职中/高中','大专','本科','博士','硕士'],
      // value: null,
      showPicker: false,
      defaultIndex:null,
    }
  },
  props:{
    defaultValue: null,
    label:"",
    placeholder:"",
    onSelect:null,
    value: null,
  },
  methods:{
    onChange: function(picker, values){
      // picker.setColumnValues(1, this.citys[values[0]]);
    },
    /**
     * 展示选择框
     */
    openSelect(){
      this.showPicker = true;

      //打开是选择默认选项
      if(this.value){
        for(let i=0;i<this.columns.length;i++){
          let val = this.columns[i];
          if(val==this.value){
            this.defaultIndex=i;
            break;
          }
        }
      }
    },
    onConfirm(value, index) {
      // if(value){
      //   this.value=value;
      // }
      this.showPicker = false;
      this.$emit("onSelect",value);
    },
    onCancel() {
      this.showPicker = false;
    },
    setValue(value){
      this.value = value;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/component/educationList.vue